import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';

const CloseBtnModal = ({ onClick, ...props }) => {
  return (
    <IconButton
      onClick={() => onClick()}
      size="small"
      {...props}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
      }}
    >
      <Close />
    </IconButton>
  );
};

export default CloseBtnModal;
